// src/components/common/ModeSwitcher.jsx
// Usage:
//   const [mode, setMode] = useState(MODES[0]);
//   <ModeSwitcher modes={MODES} value={mode} onChange={setMode} />
//
// Each mode object: { label: string, value: string, description?: string }

import { useState, useEffect } from "react";

export default function ModeSwitcher({ modes = [], value, onChange }) {
  const activeIndex = modes.findIndex((m) => m.value === value?.value);

  return (
    <div style={styles.wrap}>
      <div style={styles.track}>
        {/* Sliding pill */}
        <div
          style={{
            ...styles.pill,
            width:  `${100 / modes.length}%`,
            left:   `calc(${activeIndex} * ${100 / modes.length}%)`,
          }}
        />
        {modes.map((mode) => {
          const isActive = value?.value === mode.value;
          return (
            <button
              key={mode.value}
              onClick={() => onChange(mode)}
              style={{
                ...styles.button,
                color:      isActive ? "#0972d3" : "#5f6b7a",
                fontWeight: isActive ? 600 : 400,
              }}
            >
              {mode.label}
            </button>
          );
        })}
      </div>

      {/* Optional description under the toggle */}
      {/* {value?.description && (
        <span style={styles.hint}>{value.description}</span>
      )} */}
    </div>
  );
}

const styles = {
  wrap: {
    display:        "flex",
    flexDirection:  "column",
    alignItems:     "center",
    gap:            5,
    marginTop:      2,
    marginBottom:   2,
  },
  track: {
    position:     "relative",
    display:      "flex",
    background:   "#f1f3f5",
    borderRadius: 999,
    padding:      4,
    minWidth:     200,
  },
  pill: {
    position:   "absolute",
    top:        4,
    height:     "calc(100% - 8px)",
    background: "#fff",
    borderRadius: 999,
    border:     "1px solid #0972d3",
    boxShadow:  "0 1px 3px rgba(0,0,0,0.12)",
    transition: "left 0.22s cubic-bezier(0.4, 0, 0.2, 1)",
    pointerEvents: "none",
  },
  button: {
    position:   "relative",
    zIndex:     1,
    flex:       1,
    padding:    "6px 14px",
    border:     "none",
    background: "transparent",
    cursor:     "pointer",
    fontSize:   13,
    borderRadius: 999,
    transition: "color 0.2s ease",
    whiteSpace: "nowrap",
  },
  hint: {
    fontSize:      11,
    color:         "#8d99a5",
    textAlign:     "center",
    letterSpacing: "0.01em",
  },
};